import React from 'react';
import videojs from 'video.js'; 
import 'video.js/dist/video-js.css';
import './OpMediaPlayer.css';

export const OpMediaPlayer = ({
    onReady,
    source,
    sourceType,
}) => {
    const options = {
        autoplay: false,
        controlBar: {
            skipButtons: {
                backward: 10,
                forward: 10,
            },
        },
        controls: true,
        experimentalSvgIcons: true,
        fluid: true,
        playbackRates: [0.5, 1, 1.5, 2],
        responsive: true,
        sources: {
            src: source,
            type: sourceType
        },
    };

    const playbackRate = 1;
    const playerRef = React.useRef(null);  
    const videoRef = React.useRef(null);

    React.useEffect(() => {
        if (!playerRef.current) {
          const videoElement = document.createElement("video-js");

          videoElement.classList.add("vjs-big-play-centered");
          videoRef.current.appendChild(videoElement);

          const player = (playerRef.current = videojs(
            videoElement,
            options,
            () => {
              onReady && onReady(player);

              // Add shadow in the player
              const shadowDiv = document.createElement("div");
              shadowDiv.className = "vjs-shadow-overlay";
              player.el().appendChild(shadowDiv);
            }
          ));

          // Add audio-mode class if it's audio
          if (sourceType?.startsWith("audio")) {
            player.addClass("audio-mode");
          }
        } else {
          const player = playerRef.current;

          player.autoplay(options.autoplay);
          player.src(options.sources);

          // Add audio-mode class if it's audio
          if (sourceType?.startsWith("audio")) {
            player.addClass("audio-mode");
          } else {
            player.removeClass("audio-mode");
          }
        }
    }, [options, videoRef]);

    React.useEffect(() => {
        if (playerRef.current) {
            playerRef.current.playbackRate(playbackRate);
        }
    }, [playbackRate]);

    React.useEffect(() => {
        const player = playerRef.current;
   
        return () => {
            if (player && !player.isDisposed()) {
                player.dispose();
                playerRef.current = null;
            }
        };
      }, [playerRef]);

    return (
        <div data-vjs-player>
            <div ref={videoRef} />
        </div>
    );
};